import { BodyRegularS } from '@/styles/globals';
import { ITheme, IThemeProvider } from '@/styles/theme';
import styled from 'styled-components';

interface IShareResultsTileCont {
  theme: ITheme;
  depth?: number;
  isLastChild?: boolean;
  isVisualLastChild?: boolean;
  isExpanded?: boolean;
  isActive?: boolean;
}

const TREE_LINE_COLOR = 'rgba(0,0,0,0.15)';
const TREE_LINE_WIDTH = '1px';

export const ShareResultsTileCont = styled.div<IShareResultsTileCont>`
  display: flex;
  align-items: center;
  box-sizing: border-box;

  ${({ depth = 0, isLastChild, isActive }) =>
    depth > 0
      ? `
    &::before {
      content: '';
      position: absolute;
      left: ${10 + 12}px;
      top: 0;
      bottom: ${isLastChild ? '50%' : '0'};
      width: ${TREE_LINE_WIDTH};
      background: ${TREE_LINE_COLOR};
    }

    &::after {
      content: '';
      position: absolute;
      left: ${10 + 12}px;
      top: 50%;
      width: ${20 + (depth - 1) * 44}px;
      height: ${TREE_LINE_WIDTH};
      background: ${TREE_LINE_COLOR};
    }
  `
      : ''}

  min-height: 50px;
  position: relative;
  z-index: 10;

  ${({ theme, depth = 0, isVisualLastChild, isExpanded, isActive }) => `
    border-radius: ${
      depth === 0
        ? isActive
          ? '8px 8px 0 0'
          : '8px'
        : isVisualLastChild && !isExpanded
        ? '0 0 8px 8px'
        : '0'
    };
    width: calc(100% - ${theme.layout.spacing.mikro});

    padding-top: ${theme.layout.spacing.mikro};
    padding-bottom: ${theme.layout.spacing.mikro};
    padding-right: 41px;
    padding-left: ${depth === 0 ? 10 : 10 + depth * 24}px;

    margin: ${
      depth === 0
        ? `${theme.layout.spacing.mili} ${theme.layout.spacing.centy} ${
            isActive ? '0' : theme.layout.spacing.mikro
          } 0`
        : '0'
    };
    background: ${theme.colors.neutral.primary[0]};
    box-shadow: ${depth === 0 ? `0px 1px 1px ${theme.colors.neutral.primary[40]}` : 'none'};
    color: ${theme.colors.neutral.primary[80]};
    cursor: default;
  `}
`;

export const ShareResultsTileContentCont = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin: 0 0 0 5px;
`;

export const ShareResultsTileGroup = styled(BodyRegularS)`
  display: flex;
  align-items: center;
  width: 20%;
  min-width: 150px;
  max-width: 200px;
  @media (min-width: 1360px) {
    min-width: 180px;
    max-width: 300px;
  }
  ${({ theme }: IThemeProvider) => `
      color: ${theme.colors.neutral.primary[90]};
  `};
`;

export const ShareResultsTileAccess = styled(BodyRegularS)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 65%;
  padding-right: 48px;
  max-height: 34px;
  overflow: hidden;
  ${({ theme }: IThemeProvider) => `
      color: ${theme.colors.neutral.primary[90]};
      svg {
        cursor: pointer;
        margin: auto 0 auto 10px;
        min-width: 16px;
        min-height: 16px;

        path {
          fill: ${theme.colors.neutral.primary[80]};
        }

        &:hover {
          width: 18px;
          height: 18px;

          path {
            fill: black;
          }
        }
      }
  `};
`;

export const ShareResultsTileResponseRate = styled(BodyRegularS)`
  display: flex;
  align-items: center;
  width: 15%;
  text-transform: capitalize;
  padding-right: 6px;
  ${({ theme }: IThemeProvider) => `
      color: ${theme.colors.neutral.primary[90]};
  `};
`;

export const ShareResultsTileWrapper = styled.div`
  position: relative;
`;

export const ResizeBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  max-width: 20px;
  margin-right: 20px;
`;

export const SubReportsContainer = styled.div<{ $depth: number }>`
  display: flex;
  flex-direction: column;

  max-height: 400px;
  overflow: auto;

  scrollbar-width: none;

  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }

  ${({ theme, $depth }: IThemeProvider & { $depth: number }) => `
    margin-bottom: ${$depth === 0 ? theme.layout.spacing.mikro : '0'};
  `}
`;
